import React from 'react'

export default function TextWrapper({ style, children }) {
    return <div style={{ maxWidth: '1000px', ...style }}>{children}</div>
}
